import { useQuery } from 'react-query';
import { useParams } from 'react-router';
import Download from 'src/components/DownloadButton';
import LoadingScreen from 'src/components/LoadingScreen';
import { getRenegociationByDealId } from 'src/services/jetadmin.service';

export const RenegociationCarta: React.FC = () => {
  const { dealID } = useParams();

  const renegotiation = useQuery(
    ['renegotiation', `${dealID}`],
    () => getRenegociationByDealId({ dealId: String(dealID) }),
    {
      enabled: !!dealID,
      onSuccess: (data) => {},
    },
  );

  if (renegotiation.isLoading) return <LoadingScreen />;

  const res = renegotiation.data;
  if (!res) return <LoadingScreen />;

  const { template } = res;
  const NOME_COMPLETO = template.find(
    ({ name }) => name === 'nome_completo',
  )?.content;
  const CPF_NUMERO = template.find(
    ({ name }) => name === 'cpf_numero',
  )?.content;
  const ENDERECO_MORADOR = template.find(
    ({ name }) => name === 'endereco_morador',
  )?.content;
  const NUMERO_MORADOR = template.find(
    ({ name }) => name === 'numero_morador',
  )?.content;
  const BAIRRO_MORADOR = template.find(
    ({ name }) => name === 'bairro_morador',
  )?.content;
  const CIDADE_MORADOR = template.find(
    ({ name }) => name === 'cidade_morador',
  )?.content;
  const ESTADO_MORADOR = template.find(
    ({ name }) => name === 'estado_morador',
  )?.content;
  const CEP_MORADOR = template.find(
    ({ name }) => name === 'cep_morador',
  )?.content;
  const NUM_NOTAFISCAL = template.find(
    ({ name }) => name === 'num_notafiscal',
  )?.content;
  const VALOR_TOTAL = template.find(
    ({ name }) => name === 'valor_total',
  )?.content;
  const VALOR_TOTAL_EXTENSO = template.find(
    ({ name }) => name === 'valor_total_extenso',
  )?.content;
  const DATA_INICIO_VENCIMENTO = template.find(
    ({ name }) => name === 'data_inicio_vencimento',
  )?.content;
  const DATA_FIM_VENCIMENTO = template.find(
    ({ name }) => name === 'data_fim_vencimento',
  )?.content;
  const VALOR_PARCELA = template.find(
    ({ name }) => name === 'valor_parcela',
  )?.content;
  const NUMERO_PARCELAS = template.find(
    ({ name }) => name === 'numero_parcelas',
  )?.content;
  const VALOR_PARCELADO = template.find(
    ({ name }) => name === 'valor_parcelado',
  )?.content;
  const DATE = template.find(({ name }) => name === 'date')?.content;
  const IMAGE_SIGNATURE = res.signature;
  console.log('🚀 ~ file: RenegociationCarta.tsx:77 ~ template:', template);
  const CURRENT_YEAR = new Date().getFullYear();

  return (
    <>
      <div
        className="render-html"
        dangerouslySetInnerHTML={{
          __html: `<!doctype html>
      <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
          <head>
            <!-- NAME: WIDE -->
              <!--[if gte mso 15]>
          <xml>
            <o:OfficeDocumentSettings>
            <o:AllowPNG/>
            <o:PixelsPerInch>96</o:PixelsPerInch>
            </o:OfficeDocumentSettings>
          </xml>
          <![endif]-->
          <meta charset="UTF-8">
              <meta http-equiv="X-UA-Compatible" content="IE=edge">
              <meta name="viewport" content="width=device-width, initial-scale=1">
          <title>*|MC:SUBJECT|*</title>
              
          <style type="text/css">
          p{
            margin:10px 0;
            padding:0;
          }
          table{
            border-collapse:collapse;
          }
          h1,h2,h3,h4,h5,h6{
            display:block;
            margin:0;
            padding:0;
          }
          img,a img{
            border:0;
            height:auto;
            outline:none;
            text-decoration:none;
          }
          body,#bodyTable,#bodyCell{
            height:100%;
            margin:0;
            padding:0;
            width:100%;
          }
          .mcnPreviewText{
            display:none !important;
          }
          #outlook a{
            padding:0;
          }
          img{
            -ms-interpolation-mode:bicubic;
          }
          table{
            mso-table-lspace:0pt;
            mso-table-rspace:0pt;
          }
          .ReadMsgBody{
            width:100%;
          }
          .ExternalClass{
            width:100%;
          }
          p,a,li,td,blockquote{
            mso-line-height-rule:exactly;
          }
          a[href^=tel],a[href^=sms]{
            color:inherit;
            cursor:default;
            text-decoration:none;
          }
          p,a,li,td,body,table,blockquote{
            -ms-text-size-adjust:100%;
            -webkit-text-size-adjust:100%;
          }
          .ExternalClass,.ExternalClass p,.ExternalClass td,.ExternalClass div,.ExternalClass span,.ExternalClass font{
            line-height:100%;
          }
          a[x-apple-data-detectors]{
            color:inherit !important;
            text-decoration:none !important;
            font-size:inherit !important;
            font-family:inherit !important;
            font-weight:inherit !important;
            line-height:inherit !important;
          }
          a.mcnButton{
            display:block;
          }
          .mcnImage,.mcnRetinaImage{
            vertical-align:bottom;
          }
          .mcnTextContent{
            word-break:break-word;
          }
          .mcnTextContent img{
            height:auto !important;
          }
          .mcnDividerBlock{
            table-layout:fixed !important;
          }
        /*
        @tab Page
        @section background style
        @tip Set the background color and top border for your email. You may want to choose colors that match your company's branding.
        */
          body,#bodyTable,#templateFooter{
            /*@editable*/background-color:#275ea7;
          }
        /*
        @tab Page
        @section background style
        @tip Set the background color and top border for your email. You may want to choose colors that match your company's branding.
        */
          #bodyCell{
            /*@editable*/border-top:0;
          }
        /*
        @tab Page
        @section heading 1
        @tip Set the styling for all first-level headings in your emails. These should be the largest of your headings.
        @style heading 1
        */
          h1{
            /*@editable*/color:#202020 !important;
            /*@editable*/font-family:Helvetica;
            /*@editable*/font-size:32px;
            /*@editable*/font-style:normal;
            /*@editable*/font-weight:normal;
            /*@editable*/line-height:125%;
            /*@editable*/letter-spacing:-1px;
            /*@editable*/text-align:center;
          }
        /*
        @tab Page
        @section heading 2
        @tip Set the styling for all second-level headings in your emails.
        @style heading 2
        */
          h2{
            /*@editable*/color:#202020 !important;
            /*@editable*/font-family:Helvetica;
            /*@editable*/font-size:26px;
            /*@editable*/font-style:normal;
            /*@editable*/font-weight:normal;
            /*@editable*/line-height:125%;
            /*@editable*/letter-spacing:-.75px;
            /*@editable*/text-align:left;
          }
        /*
        @tab Page
        @section heading 3
        @tip Set the styling for all third-level headings in your emails.
        @style heading 3
        */
          h3{
            /*@editable*/color:#202020 !important;
            /*@editable*/font-family:Helvetica;
            /*@editable*/font-size:18px;
            /*@editable*/font-style:normal;
            /*@editable*/font-weight:normal;
            /*@editable*/line-height:125%;
            /*@editable*/letter-spacing:-.5px;
            /*@editable*/text-align:left;
          }
        /*
        @tab Page
        @section heading 4
        @tip Set the styling for all fourth-level headings in your emails. These should be the smallest of your headings.
        @style heading 4
        */
          h4{
            /*@editable*/color:#202020 !important;
            /*@editable*/font-family:Helvetica;
            /*@editable*/font-size:16px;
            /*@editable*/font-style:normal;
            /*@editable*/font-weight:normal;
            /*@editable*/line-height:125%;
            /*@editable*/letter-spacing:normal;
            /*@editable*/text-align:left;
          }
        /*
        @tab Preheader
        @section preheader style
        @tip Set the background color and borders for your email's preheader area.
        */
          #templatePreheader{
            /*@editable*/background-color:#275ea7;
            /*@editable*/border-top:0;
            /*@editable*/border-bottom:0;
          }
        /*
        @tab Preheader
        @section preheader text
        @tip Set the styling for your email's preheader text. Choose a size and color that is easy to read.
        */
          .preheaderContainer .mcnTextContent,.preheaderContainer .mcnTextContent p{
            /*@editable*/color:#FAFAFA;
            /*@editable*/font-family:Helvetica;
            /*@editable*/font-size:0px;
            /*@editable*/line-height:125%;
            /*@editable*/text-align:left;
          }
        /*
        @tab Preheader
        @section preheader link
        @tip Set the styling for your email's header links. Choose a color that helps them stand out from your text.
        */
          .preheaderContainer .mcnTextContent a{
            /*@editable*/color:#FAFAFA;
            /*@editable*/font-weight:normal;
            /*@editable*/text-decoration:underline;
          }
        /*
        @tab Header
        @section header style
        @tip Set the background color and borders for your email's header area.
        */
          #templateHeader{
            /*@editable*/background-color:#275ea7;
            /*@editable*/border-top:0;
            /*@editable*/border-bottom:0;
          }
        /*
        @tab Header
        @section header text
        @tip Set the styling for your email's header text. Choose a size and color that is easy to read.
        */
          .headerContainer .mcnTextContent,.headerContainer .mcnTextContent p{
            /*@editable*/color:#202020;
            /*@editable*/font-family:Helvetica;
            /*@editable*/font-size:14px;
            /*@editable*/line-height:150%;
            /*@editable*/text-align:left;
          }
        /*
        @tab Header
        @section header link
        @tip Set the styling for your email's header links. Choose a color that helps them stand out from your text.
        */
          .headerContainer .mcnTextContent a{
            /*@editable*/color:#26ABE2;
            /*@editable*/font-weight:normal;
            /*@editable*/text-decoration:underline;
          }
        /*
        @tab Body
        @section body style
        @tip Set the background color and borders for your email's body area.
        */
          #templateBody{
            /*@editable*/background-color:#ffffff;
            /*@editable*/border-top:0;
            /*@editable*/border-bottom:0;
          }
        /*
        @tab Body
        @section body text
        @tip Set the styling for your email's body text. Choose a size and color that is easy to read.
        */
          .bodyContainer .mcnTextContent,.bodyContainer .mcnTextContent p{
            /*@editable*/color:#202020;
            /*@editable*/font-family:Helvetica;
            /*@editable*/font-size:14px;
            /*@editable*/line-height:150%;
            /*@editable*/text-align:left;
          }
        /*
        @tab Body
        @section body link
        @tip Set the styling for your email's body links. Choose a color that helps them stand out from your text.
        */
          .bodyContainer .mcnTextContent a{
            /*@editable*/color:#26ABE2;
            /*@editable*/font-weight:normal;
            /*@editable*/text-decoration:underline;
          }
        /*
        @tab Footer
        @section footer style
        @tip Set the background color and borders for your email's footer area.
        */
          #templateFooter{
            /*@editable*/border-top:1px none ;
            /*@editable*/border-bottom:0;
          }
        /*
        @tab Footer
        @section footer text
        @tip Set the styling for your email's footer text. Choose a size and color that is easy to read.
        */
          .footerContainer .mcnTextContent,.footerContainer .mcnTextContent p{
            /*@editable*/color:#202020;
            /*@editable*/font-family:Helvetica;
            /*@editable*/font-size:10px;
            /*@editable*/line-height:125%;
            /*@editable*/text-align:left;
          }
        /*
        @tab Footer
        @section footer link
        @tip Set the styling for your email's footer links. Choose a color that helps them stand out from your text.
        */
          .footerContainer .mcnTextContent a{
            /*@editable*/color:#202020;
            /*@editable*/font-weight:normal;
            /*@editable*/text-decoration:underline;
          }
        @media only screen and (max-width: 480px){
          body,table,td,p,a,li,blockquote{
            -webkit-text-size-adjust:none !important;
          }
      
      }	@media only screen and (max-width: 480px){
          body{
            width:100% !important;
            min-width:100% !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .templateContainer{
            max-width:600px !important;
            width:100% !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .mcnRetinaImage{
            max-width:100% !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .mcnImage{
            height:auto !important;
            width:100% !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .mcnCartContainer,.mcnCaptionTopContent,.mcnRecContentContainer,.mcnCaptionBottomContent,.mcnTextContentContainer,.mcnBoxedTextContentContainer,.mcnImageGroupContentContainer,.mcnCaptionLeftTextContentContainer,.mcnCaptionRightTextContentContainer,.mcnCaptionLeftImageContentContainer,.mcnCaptionRightImageContentContainer,.mcnImageCardLeftTextContentContainer,.mcnImageCardRightTextContentContainer,.mcnImageCardLeftImageContentContainer,.mcnImageCardRightImageContentContainer{
            max-width:100% !important;
            width:100% !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .mcnBoxedTextContentContainer{
            min-width:100% !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .mcnImageGroupContent{
            padding:9px !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .mcnCaptionLeftContentOuter .mcnTextContent,.mcnCaptionRightContentOuter .mcnTextContent{
            padding-top:9px !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .mcnImageCardTopImageContent,.mcnCaptionBottomContent:last-child .mcnCaptionBottomImageContent,.mcnCaptionBlockInner .mcnCaptionTopContent:last-child .mcnTextContent{
            padding-top:18px !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .mcnImageCardBottomImageContent{
            padding-bottom:9px !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .mcnImageGroupBlockInner{
            padding-top:0 !important;
            padding-bottom:0 !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .mcnImageGroupBlockOuter{
            padding-top:9px !important;
            padding-bottom:9px !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .mcnTextContent,.mcnBoxedTextContentColumn{
            padding-right:18px !important;
            padding-left:18px !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .mcnImageCardLeftImageContent,.mcnImageCardRightImageContent{
            padding-right:18px !important;
            padding-bottom:0 !important;
            padding-left:18px !important;
          }
      
      }	@media only screen and (max-width: 480px){
          .mcpreview-image-uploader{
            display:none !important;
            width:100% !important;
          }
      
      }	@media only screen and (max-width: 480px){
        /*
        @tab Mobile Styles
        @section heading 1
        @tip Make the first-level headings larger in size for better readability on small screens.
        */
          h1{
            /*@editable*/font-size:24px !important;
            /*@editable*/line-height:125% !important;
          }
      
      }	@media only screen and (max-width: 480px){
        /*
        @tab Mobile Styles
        @section heading 2
        @tip Make the second-level headings larger in size for better readability on small screens.
        */
          h2{
            /*@editable*/font-size:20px !important;
            /*@editable*/line-height:125% !important;
          }
      
      }	@media only screen and (max-width: 480px){
        /*
        @tab Mobile Styles
        @section heading 3
        @tip Make the third-level headings larger in size for better readability on small screens.
        */
          h3{
            /*@editable*/font-size:18px !important;
            /*@editable*/line-height:125% !important;
          }
      
      }	@media only screen and (max-width: 480px){
        /*
        @tab Mobile Styles
        @section heading 4
        @tip Make the fourth-level headings larger in size for better readability on small screens.
        */
          h4{
            /*@editable*/font-size:16px !important;
            /*@editable*/line-height:125% !important;
          }
      
      }	@media only screen and (max-width: 480px){
        /*
        @tab Mobile Styles
        @section Boxed Text
        @tip Make the boxed text larger in size for better readability on small screens. We recommend a font size of at least 16px.
        */
          .mcnBoxedTextContentContainer .mcnTextContent,.mcnBoxedTextContentContainer .mcnTextContent p{
            /*@editable*/font-size:18px !important;
            /*@editable*/line-height:125% !important;
          }
      
      }	@media only screen and (max-width: 480px){
        /*
        @tab Mobile Styles
        @section Preheader Visibility
        @tip Set the visibility of the email's preheader on small screens. You can hide it to save space.
        */
          #templatePreheader{
            /*@editable*/display:block !important;
          }
      
      }	@media only screen and (max-width: 480px){
        /*
        @tab Mobile Styles
        @section Preheader Text
        @tip Make the preheader text larger in size for better readability on small screens.
        */
          .preheaderContainer .mcnTextContent,.preheaderContainer .mcnTextContent p{
            /*@editable*/font-size:14px !important;
            /*@editable*/line-height:115% !important;
          }
      
      }	@media only screen and (max-width: 480px){
        /*
        @tab Mobile Styles
        @section Header Text
        @tip Make the header text larger in size for better readability on small screens.
        */
          .headerContainer .mcnTextContent,.headerContainer .mcnTextContent p{
            /*@editable*/font-size:18px !important;
            /*@editable*/line-height:125% !important;
          }
      
      }	@media only screen and (max-width: 480px){
        /*
        @tab Mobile Styles
        @section Body Text
        @tip Make the body text larger in size for better readability on small screens. We recommend a font size of at least 16px.
        */
          .bodyContainer .mcnTextContent,.bodyContainer .mcnTextContent p{
            /*@editable*/font-size:18px !important;
            /*@editable*/line-height:125% !important;
          }
      
      }	@media only screen and (max-width: 480px){
        /*
        @tab Mobile Styles
        @section footer text
        @tip Make the body content text larger in size for better readability on small screens.
        */
          .footerContainer .mcnTextContent,.footerContainer .mcnTextContent p{
            /*@editable*/font-size:14px !important;
            /*@editable*/line-height:115% !important;
          }
      
      }</style>
                                    <script>!function(a){var e="https://s.go-mpulse.net/boomerang/",t="addEventListener";if("True"=="True")a.BOOMR_config=a.BOOMR_config||{},a.BOOMR_config.PageParams=a.BOOMR_config.PageParams||{},a.BOOMR_config.PageParams.pci=!0,e="https://s2.go-mpulse.net/boomerang/";if(window.BOOMR_API_key="QAT5G-9HZLF-7EDMX-YMVCJ-QZJDA",function(){function n(e){a.BOOMR_onload=e&&e.timeStamp||(new Date).getTime()}if(!a.BOOMR||!a.BOOMR.version&&!a.BOOMR.snippetExecuted){a.BOOMR=a.BOOMR||{},a.BOOMR.snippetExecuted=!0;var i,_,o,r=document.createElement("iframe");if(a[t])a[t]("load",n,!1);else if(a.attachEvent)a.attachEvent("onload",n);r.src="javascript:void(0)",r.title="",r.role="presentation",(r.frameElement||r).style.cssText="width:0;height:0;border:0;display:none;",o=document.getElementsByTagName("script")[0],o.parentNode.insertBefore(r,o);try{_=r.contentWindow.document}catch(O){i=document.domain,r.src="javascript:var d=document.open();d.domain='"+i+"';void(0);",_=r.contentWindow.document}_.open()._l=function(){var a=this.createElement("script");if(i)this.domain=i;a.id="boomr-if-as",a.src=e+"QAT5G-9HZLF-7EDMX-YMVCJ-QZJDA",BOOMR_lstart=(new Date).getTime(),this.body.appendChild(a)},_.write("<bo"+'dy onload="document._l();">'),_.close()}}(),"".length>0)if(a&&"performance"in a&&a.performance&&"function"==typeof a.performance.setResourceTimingBufferSize)a.performance.setResourceTimingBufferSize();!function(){if(BOOMR=a.BOOMR||{},BOOMR.plugins=BOOMR.plugins||{},!BOOMR.plugins.AK){var e=""=="true"?1:0,t="",n="x4jxaoqxe2ijuzirvlpq-f-00a8c29e5-clientnsv4-s.akamaihd.net",i="false"=="true"?2:1,_={"ak.v":"36","ak.cp":"314244","ak.ai":parseInt("199322",10),"ak.ol":"0","ak.cr":6,"ak.ipv":4,"ak.proto":"h2","ak.rid":"14d4cf6a","ak.r":47038,"ak.a2":e,"ak.m":"x","ak.n":"essl","ak.bpcip":"191.19.112.0","ak.cport":49716,"ak.gh":"2.19.9.197","ak.quicv":"","ak.tlsv":"tls1.3","ak.0rtt":"","ak.csrc":"-","ak.acc":"","ak.t":"1695656671","ak.ak":"hOBiQwZUYzCg5VSAfCLimQ==nJJg9Xo+F/6LyZhBN+I8JGewS1KB/xMolW73NLP5+ybsSDUR5/IB3E9aMEzFNrSjNoU2tt/3qMs47dEJVZdGuUTUEjKn9aLoPn+UpEon9jvnfkEP+CwwrdeNKMOX28ye7yXkENBMZh+afuCDUh6GwLV5SOg0eAFX7YzgVkDZ/whO7JnE8g03iuGRcSLfYccHCsw/D018X25uRqPgX1E3uWSnQCF4/aSVneZbPzcSzynzhhAVWjZcwdZ4QmIL10qgDLJds3Y1Y/K88bDksf1Zg4rdXclfcQGgEk5aijD0VjoFtEZu/bZLRoWZbN6QBVPhioXxNl6SHcSU9fbMM1GB8FL1FtimDC+oSCq2/8UGuUDkQs6/uJS/i21g5qgM8YTEqBzsDN92eOUovYoN+tpKqb+FaH1cIxChXT0achF2uEY=","ak.pv":"157","ak.dpoabenc":"","ak.tf":i};if(""!==t)_["ak.ruds"]=t;var o={i:!1,av:function(e){var t="http.initiator";if(e&&(!e[t]||"spa_hard"===e[t]))_["ak.feo"]=void 0!==a.aFeoApplied?1:0,BOOMR.addVar(_)},rv:function(){var a=["ak.bpcip","ak.cport","ak.cr","ak.csrc","ak.gh","ak.ipv","ak.m","ak.n","ak.ol","ak.proto","ak.quicv","ak.tlsv","ak.0rtt","ak.r","ak.acc","ak.t","ak.tf"];BOOMR.removeVar(a)}};BOOMR.plugins.AK={akVars:_,akDNSPreFetchDomain:n,init:function(){if(!o.i){var a=BOOMR.subscribe;a("before_beacon",o.av,null,null),a("onbeacon",o.rv,null,null),o.i=!0}return this},is_complete:function(){return!0}}}}()}(window);</script></head>
          <body leftmargin="0" marginwidth="0" topmargin="0" marginheight="0" offset="0">
              <!--*|IF:MC_PREVIEW_TEXT|*-->
              <!--[if !gte mso 9]><!----><span class="mcnPreviewText" style="display:none; font-size:0px; line-height:0px; max-height:0px; max-width:0px; opacity:0; overflow:hidden; visibility:hidden; mso-hide:all;">*|MC_PREVIEW_TEXT|*</span><!--<![endif]-->
              <!--*|END:IF|*-->
              <center>
                  <table align="center" border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTable">
                      <tr>
                          <td align="center" valign="top" id="bodyCell" style="padding-bottom:40px;">
                              <!-- BEGIN TEMPLATE // -->
                              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                                  <tr>
                                      <td align="center" valign="top">
                                          <!-- BEGIN PREHEADER // -->
                                          <table border="0" cellpadding="0" cellspacing="0" width="100%" id="templatePreheader">
                                              <tr>
                                                <td align="center" valign="top">
                                                      <table border="0" cellpadding="0" cellspacing="0" width="640" class="templateContainer">
                                                          <tr>
                                                              <td valign="top" class="preheaderContainer" style="padding-top:9px; padding-bottom:9px;"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">
          <tbody class="mcnTextBlockOuter">
              <tr>
                  <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">
                      <!--[if mso]>
              <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
              <tr>
              <![endif]-->
                
              <!--[if mso]>
              <td valign="top" width="640" style="width:640px;">
              <![endif]-->
                      <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">
                          <tbody><tr>
                              
                              <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">
                              
                                  
                              </td>
                          </tr>
                      </tbody></table>
              <!--[if mso]>
              </td>
              <![endif]-->
                      
              <!--[if mso]>
              </tr>
              </table>
              <![endif]-->
                  </td>
              </tr>
          </tbody>
      </table></td>
                                                          </tr>
                                                      </table>
                                                  </td>                                            
                                              </tr>
                                          </table>
                                          <!-- // END PREHEADER -->
                                      </td>
                                  </tr>
                                  <tr>
                                      <td align="center" valign="top">
                                          <!-- BEGIN HEADER // -->
                                          <table border="0" cellpadding="0" cellspacing="0" width="100%" id="templateHeader">
                                              <tr>
                                                  <td align="center" valign="top">
                                                      <table border="0" cellpadding="0" cellspacing="0" width="640" class="templateContainer">
                                                          <tr>
                                                              <td valign="top" class="headerContainer" style="padding-top:9px; padding-bottom:9px;"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnImageBlock" style="min-width:100%;">
          <tbody class="mcnImageBlockOuter">
                  <tr>
                      <td valign="top" style="padding:9px" class="mcnImageBlockInner">
                          <table align="left" width="100%" border="0" cellpadding="0" cellspacing="0" class="mcnImageContentContainer" style="min-width:100%;">
                              <tbody><tr>
                                  <td class="mcnImageContent" valign="top" style="padding-right: 9px; padding-left: 9px; padding-top: 0; padding-bottom: 0;">
                                      
                                          
                                              <img align="left" alt="" src="https://mcusercontent.com/600aa378f2b3163bca25f4339/images/95f16376-b7bc-4a93-8215-793a3e2eacdd.png" width="320.12" style="max-width: 1080px; padding-bottom: 0px; vertical-align: bottom; display: inline !important; border-radius: 0%;" class="mcnImage">
                                          
                                      
                                  </td>
                              </tr>
                          </tbody></table>
                      </td>
                  </tr>
          </tbody>
      </table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">
          <tbody class="mcnTextBlockOuter">
              <tr>
                  <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">
                      <!--[if mso]>
              <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
              <tr>
              <![endif]-->
                
              <!--[if mso]>
              <td valign="top" width="640" style="width:640px;">
              <![endif]-->
                      <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">
                          <tbody><tr>
                              
                              <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">
                              
                                  
                              </td>
                          </tr>
                      </tbody></table>
              <!--[if mso]>
              </td>
              <![endif]-->
                      
              <!--[if mso]>
              </tr>
              </table>
              <![endif]-->
                  </td>
              </tr>
          </tbody>
      </table></td>
                                                          </tr>
                                                      </table>
                                                  </td>
                                              </tr>
                                          </table>
                                          <!-- // END HEADER -->
                                      </td>
                                  </tr>
                                  <tr>
                                      <td align="center" valign="top">
                                          <!-- BEGIN BODY // -->
                                          <table border="0" cellpadding="0" cellspacing="0" width="100%" id="templateBody">
                                              <tr>
                                                  <td align="center" valign="top">
                                                      <table border="0" cellpadding="0" cellspacing="0" width="640" class="templateContainer">
                                                          <tr>
                                                              <td valign="top" class="bodyContainer" style="padding-top:9px; padding-bottom:9px;"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">
          <tbody class="mcnTextBlockOuter">
              <tr>
                  <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">
                      <!--[if mso]>
              <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
              <tr>
              <![endif]-->
                
              <!--[if mso]>
              <td valign="top" width="640" style="width:640px;">
              <![endif]-->
                      <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">
                          <tbody><tr>
                              
                              <td valign="top" class="mcnTextContent" style="padding: 0px 18px 9px;color: #000000;font-size: 13px;">
                              
                                  <h1><strong>Termo de Confissão de Dívida</strong></h1>
      
                              </td>
                          </tr>
                      </tbody></table>
              <!--[if mso]>
              </td>
              <![endif]-->
                      
              <!--[if mso]>
              </tr>
              </table>
              <![endif]-->
                  </td>
              </tr>
          </tbody>
      </table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">
          <tbody class="mcnTextBlockOuter">
              <tr>
                  <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">
                      <!--[if mso]>
              <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
              <tr>
              <![endif]-->
                
              <!--[if mso]>
              <td valign="top" width="640" style="width:640px;">
              <![endif]-->
                      <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">
                          <tbody><tr>
                              
                              <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">
                              
                                  <span style="font-size:16px">Eu, ${NOME_COMPLETO}, inscrita no CPF/MF sob nº ${CPF_NUMERO}, com residência na ${ENDERECO_MORADOR}, ${NUMERO_MORADOR}, ${BAIRRO_MORADOR}, ${CIDADE_MORADOR} - ${ESTADO_MORADOR}, CEP: ${CEP_MORADOR}, CONFESSO a existência de um débito para com a empresa EDITORA NAPOLEÃO LTDA; esta devidamente inscrita no CNPJ sob nº 06.228.693/0001-50; oriundo da(s) Nota(s) Fiscal(is) ${NUM_NOTAFISCAL}, no valor de ${VALOR_TOTAL} (${VALOR_TOTAL_EXTENSO}) referente às parcelas com vencimentos de ${DATA_INICIO_VENCIMENTO} à ${DATA_FIM_VENCIMENTO} que serão atualizadas pela correção monetária do IPCA, mais mora 1% a.m. e mais multa de 10%, serão pagas da seguinte forma:<br>
      Valor de ${VALOR_PARCELA} em ${NUMERO_PARCELAS} parcelas de&nbsp; ${VALOR_PARCELADO}, os pagamentos ocorrerão via boleto bancário encaminhado pela credora EDITORA NAPOLEÃO LTDA.<br>
      A partir da assinatura do presente instrumento, o DEVEDOR terá o prazo de 10 dias corridos para realização do pagamento da primeira parcela ora convencionada, sendo que a partir da data do pagamento, serão lançadas, de maneira consecutiva, as próximas parcelas para o mesmo dia dos meses subsequentes.<br>
      Em caso de ausência de pagamento pontual ou atraso no pagamento da primeira parcela, na forma da cláusula anterior, considerar-se-á como data de vencimento o primeiro dia da contagem ora prevista, sendo exigíveis as demais parcelas para o mesmo dia dos meses subsequentes, de maneira consecutiva.<br>
      Caso verificada a inadimplência, a dívida será declarada vencida antecipadamente com a imposição de correção monetária de acordo com a variação do IPCA acrescidos da multa de 20% (vinte por cento), além de juros de 1% (um por cento) ao mês.<br>
      Informamos ainda, que o não contato na data aprazada, implicará na imediata tomada das medidas legais da espécie, na esfera civil.<br>
      <br>
      Para dirimir quaisquer controvérsias oriundas do contrato, as partes elegem o foro da comarca de Nova Odessa, Estado de São Paulo, por mais privilegiado que outro possa existir.&nbsp;<br>
      <br>
      Por estarem assim justos e contratados, firmam o presente instrumento, em 2 (duas) vias de igual teor, juntamente a 2 (duas) testemunhas.<br>
      <br>
      Nova Odessa, ${DATE}.</span><br>
      <br>
      &nbsp;
      <hr><br>
      &nbsp;
                              </td>
                          </tr>
                      </tbody></table>
              <!--[if mso]>
              </td>
              <![endif]-->
                      
              <!--[if mso]>
              </tr>
              </table>
              <![endif]-->
                  </td>
              </tr>
          </tbody>
      </table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">
          <tbody class="mcnTextBlockOuter">
              <tr>
                  <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">
                      <!--[if mso]>
              <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
              <tr>
              <![endif]-->
                
              <!--[if mso]>
              <td valign="top" width="640" style="width:640px;">
              <![endif]-->
                      <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">
                          <tbody><tr>
                              
                              <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">
                              
                                  <div style="width:100%; display: flex; flex-wrap: wrap">
      <div style="display: flex-inline;padding:15px"><a href="${IMAGE_SIGNATURE}"><img height="99" src="${IMAGE_SIGNATURE}" style="border: 0px; display: block; width: 250px; transform: translate(-30px, 21px); height: 99px; margin: 0px;"></a>
      
      <div style="width:230px; border-bottom: 2px black solid; height: 0"><br>
      &nbsp;</div>
      
      <p>Sua Assinatura</p>
      </div>
      </div>
      
      <div style="width:100%; display: flex; ">
      <div style="display: flex-inline"><img src="https://mcusercontent.com/600aa378f2b3163bca25f4339/images/5bc021ab-fb44-3d96-fc28-772b0e54be4a.png" style="display:block; width:250px; transform: translate(-20px, 21px)">
      <div style="width:230px; border-bottom: 2px black solid; height: 0">&nbsp;</div>
      
      <p>Editora Napoleão<br>
      Leonardo Napoleão<br>
      CPF 259.649.208-37</p>
      </div>
      
      <div style="display: flex-inline"><img src="https://mcusercontent.com/600aa378f2b3163bca25f4339/images/3e7c801c-e893-7b2d-b1e7-ec7fe2f6c1a1.png" style="display:block; width:250px; transform: translate(-10px, 21px)">
      <div style="width:230px; border-bottom: 2px black solid; height: 0">&nbsp;</div>
      
      <p>Nivia Thiarls Martins Batista<br>
      CPF 314.110.578-21</p>
      </div>
      
      <div style="display: flex-inline"><img data-file-id="7236520" height="99" src="https://mcusercontent.com/600aa378f2b3163bca25f4339/images/18debe37-90f1-a580-de46-8456d83d6ac2.png" style="display:block; width:250px; transform: translate(-0px, 21px)">
      <div style="width:230px; border-bottom: 2px black solid; height: 0">&nbsp;</div>
      
      <p>Ruth Domingos Pedro<br>
      CPF 373.435.628-86</p>
      </div>
      </div>
      
                              </td>
                          </tr>
                      </tbody></table>
              <!--[if mso]>
              </td>
              <![endif]-->
                      
              <!--[if mso]>
              </tr>
              </table>
              <![endif]-->
                  </td>
              </tr>
          </tbody>
      </table></td>
                                                          </tr>
                                                      </table>
                                                  </td>
                                              </tr>
                                          </table>
                                          <!-- // END BODY -->
                                      </td>
                                  </tr>
                                  <tr>
                                      <td align="center" valign="top">
                                          <!-- BEGIN FOOTER // -->
                                          <table border="0" cellpadding="0" cellspacing="0" width="100%" id="templateFooter">
                                              <tr>
                                                  <td align="center" valign="top">
                                                      <table border="0" cellpadding="0" cellspacing="0" width="640" class="templateContainer">
                                                          <tr>
                                                              <td valign="top" class="footerContainer" style="padding-top:9px; padding-bottom:9px;"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">
          <tbody class="mcnDividerBlockOuter">
              <tr>
                  <td class="mcnDividerBlockInner" style="min-width: 100%; padding: 18px 18px 36px;">
                      <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width: 100%;border-top: 1px solid #DDDDDD;">
                          <tbody><tr>
                              <td>
                                  <span></span>
                              </td>
                          </tr>
                      </tbody></table>
      <!--            
                      <td class="mcnDividerBlockInner" style="padding: 18px;">
                      <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
      -->
                  </td>
              </tr>
          </tbody>
      </table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">
          <tbody class="mcnTextBlockOuter">
              <tr>
                  <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">
                      <!--[if mso]>
              <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
              <tr>
              <![endif]-->
                
              <!--[if mso]>
              <td valign="top" width="640" style="width:640px;">
              <![endif]-->
                      <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">
                          <tbody><tr>
                              
                              <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">
                              
                                  <div style="text-align: center;"><img data-file-id="7201996" height="108" src="https://mcusercontent.com/600aa378f2b3163bca25f4339/images/95f16376-b7bc-4a93-8215-793a3e2eacdd.png" style="border: 0px  ; width: 500px; height: 108px; margin: 0px;" width="600"><br>
      <a href="https://www.facebook.com/editoranapoleaoquintessence" target="_blank"><img data-file-id="2646381" height="288" src="https://mcusercontent.com/e769651e9836ef6adce60661b/images/05e6a748-5375-0aaf-ea4d-675a360f3d3b.png" style="border: 0px initial ; padding: 10px; width: 50px; height: 288px; margin: 0px;" width="50"></a><a href="https://www.instagram.com/editoranapoleaoquintessence/"><img data-file-id="2646385" height="288" src="https://mcusercontent.com/e769651e9836ef6adce60661b/images/583027ea-57e5-5dd5-5434-07a29832bcc0.png" style="border: 0px initial ; padding: 10px; width: 50px; height: 288px; margin: 0px;" width="50"></a><a href="https://www.linkedin.com/company/editoranapoleaoquintessence/"><img data-file-id="2646393" height="288" src="https://mcusercontent.com/e769651e9836ef6adce60661b/images/334c4736-6e0d-5863-9350-93c977eb07f7.png" style="border: 0px  ; padding: 10px; width: 50px; height: 288px; margin: 0px;" width="50"></a></div>
      
                              </td>
                          </tr>
                      </tbody></table>
              <!--[if mso]>
              </td>
              <![endif]-->
                      
              <!--[if mso]>
              </tr>
              </table>
              <![endif]-->
                  </td>
              </tr>
          </tbody>
      </table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">
          <tbody class="mcnTextBlockOuter">
              <tr>
                  <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">
                      <!--[if mso]>
              <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
              <tr>
              <![endif]-->
                
              <!--[if mso]>
              <td valign="top" width="640" style="width:640px;">
              <![endif]-->
                      <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">
                          <tbody><tr>
                              
                              <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">
                              
                                  <div style="text-align: center;"><span style="font-size:14px"><em>Copyright © </em></span><em>${CURRENT_YEAR}</em><span style="font-size:14px"><em>&nbsp;Napoleão. To</em>dos os direitos reservados.</span></div>
      
                              </td>
                          </tr>
                      </tbody></table>
              <!--[if mso]>
              </td>
              <![endif]-->
                      
              <!--[if mso]>
              </tr>
              </table>
              <![endif]-->
                  </td>
              </tr>
          </tbody>
      </table></td>
                                                          </tr>
                                                      </table>
                                                  </td>
                                              </tr>
                                          </table>
                                          <!-- // END FOOTER -->
                                      </td>
                                  </tr>
                              </table>
                              <!-- // END TEMPLATE -->
                          </td>
                      </tr>
                  </table>
              </center>
          <script type="text/javascript"  src="/6s31M6Xp_z2yANrLZM1vn9E5/h3wubtVDbJ/fhE3IRYeBQ/UxQla/1gMHB0B"></script></body>
      </html>
      `,
        }}
      />
      <Download />
    </>
  );
};
